<template>
  <section v-if="products?.length" class="container">
    <h2 class="is-2 leading-none mb-40">
      {{ title }}
    </h2>
    <div class="grid gap-15 lg:gap-25 grid-cols-2 lg:grid-cols-4">
      <ProductTeaser
        v-for="product in products"
        v-bind="product"
        :key="product.title"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ProductTeaserFragment } from '#build/graphql-operations'

defineProps<{
  title: string
  products?: ProductTeaserFragment[]
}>()
</script>
